export default "__VITE_ASSET__B0S4lJnj__"